<mat-card>
  <mat-card-header>
    <mat-card-title>Вход в систему</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <form [formGroup]="loginForm"
          (ngSubmit)="onSubmit($event)">
      <mat-form-field appearance="standard">
        <mat-label>Почта</mat-label>
        <input matInput
               type="text"
               formControlName="mail"
               placeholder="Введите почту">
      </mat-form-field>
      <mat-form-field appearance="standard">
        <mat-label>Пароль</mat-label>
        <input matInput
               #password
               [type]="passwordHide ? 'password' : 'text'"
               formControlName="password"
               placeholder="Введите пароль">
        <button mat-icon-button matSuffix
                type="button"
                [matTooltip]="passwordHide ? 'Отобразить пароль' : 'Скрыть пароль'"
                [attr.aria-pressed]="passwordHide"
                (click)="passwordHide = !passwordHide">
          <mat-icon>{{passwordHide ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
      </mat-form-field>
      <div *ngIf="error" class="error">
        {{ error }}
      </div>
      <div class="buttons">
        <button mat-flat-button
                color="primary"
                type="submit"
                [disabled]="!loginForm.valid">Войти
        </button>
      </div>
    </form>
  </mat-card-content>
</mat-card>
